import { render, staticRenderFns } from "./c_menu.vue?vue&type=template&id=7a4de37b&scoped=true"
import script from "./c_menu.vue?vue&type=script&lang=js"
export * from "./c_menu.vue?vue&type=script&lang=js"
import style0 from "./c_menu.vue?vue&type=style&index=0&id=7a4de37b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4de37b",
  null
  
)

export default component.exports